<template>
  <div class="tpl">
    <van-nav-bar title="闲置详情" left-text="返回"  left-arrow fixed @click-left="onClickLeft" right-text="关注" @click-right="onClickRight" />
    <div style="height:46px"></div>
    <div class="title">{{item.title}}</div>
    <div class="user">
      <div class="av">
        <img :src="item.avatar" />
      </div>
      <div class="right">{{item.lx_name}} {{item.mobile}}</div>
    </div>
    <div class="address">{{item.city.area_name}} {{item.district.area_name}} {{item.address}}</div>
    <div class="content">{{item.content}}</div>
    <div class="thumbnail">
      <div>
        <img v-for="i in item.img" :src="GLOBAL.IMG + i" :key="i" />
      </div>
    </div>
    <div style="background-color:#fff;padding:10px;margin-top:10px">
      <div style="font-size:16px;font-base:500">全部留言</div>
      <van-list
        class="goodsList"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <router-link class="item" v-for="item in list" :key="item.id">
          <div class="title">{{item.content}}</div>

          <div class="userInfo">
            <div class="av">
              <img :src="item.avatar" />
            </div>
            <div class="user-name">{{item.user_nickname}}</div>
          </div>
        </router-link>
      </van-list>
    </div>
    <div style="margin-top:10px">
      <van-cell-group>
        <van-field
          v-model="liuyan.content"
          rows="2"
          autosize
          label="留言"
          type="textarea"
          maxlength="50"
          placeholder="请输入留言"
          show-word-limit
        >
          <template #button>
            <van-button size="small" v-on:click="postLiuYan()" type="primary">发送</van-button>
          </template>
        </van-field>
      </van-cell-group>
    </div>
    <div style="height:50px"></div>
  </div>
</template>
<script>
import wx_share from '../../common/wx_share.js';
export default {
  name: "secondDetail",
  data() {
    return {
      id: this.$route.params.id,
      user: { token: "",user:{id:0} },
      item: { city: { area_name: "" }, district: { area_name: "" } },
      list: [],
      loading: false,
      finished: false,
      cPage: 1,
      liuyan:{content:''},
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight(){
        this.$router.push("/article/detail/71");
    },
    goHome() {
      this.$router.push("/");
    },
    getDetail() {
      this.$http
        .get(this.GLOBAL.API + "s_xianyu/Supply/supply_detail", {
          params: { supply_id: this.id },
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.item = data.data;
            this.item['post_title']=this.item.title;
            this.item['desc']=this.item.title;
            this.item['thumbnail']= 'http://yijia.sihandbms.cn/upload/'+this.item.img[0];
            wx_share.wx_share(this.GLOBAL.API,this.user,this.item);
          }
        });
    },
    postLiuYan() {
      this.$http
        .post(this.GLOBAL.API + "s_xianyu/Pladd/comment_add",{user_id:'',supply_id:this.id,content:this.liuyan.content}, {
          params: {},
          headers: { "XX-Token": this.user.token,"XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.$toast(data.msg);
          }
        });
    },
    onLoad() {
      this.$http
        .get(this.GLOBAL.API + "s_xianyu/Comment/comment_list", {
          params: { supply_id: this.id, page: this.cPage }, //id=19求购，id=21出售
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          this.loading = false;
          if (this.cPage >= data.data.last_page) {
            this.finished = true;
          } else {
            this.cPage++;
          }
          if (data.code == 1) {
            this.list = this.list.concat(data.data.data); //= data.data.data;
          }
        });
    }
  },
  mounted() {
    
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.tpl {
  text-align: left;
  background-color: #f6f6f6;
}

.price {
  color: #f2270c;
  em {
    font-size: 30px;
    font-family: JDZH-Regular;
  }
  padding: 10px;
  background-color: #ffffff;
}
.title {
  font-size: 16px;
  color: #262626;
  font-weight: 700;
  padding: 10px;
  margin-top: 10px;
  border-radius: 0 0 10px 10px;
  background-color: #ffffff;
}
.content {
  padding: 10px;
  background-color: #fff;
  overflow: hidden;
  margin-top: 10px;
}
.thumbnail {
  padding: 10px;
  background-color: #fff;
  margin: 10px 0 0 0;
  div {
    border-radius: 10px;
    overflow: hidden;
    img {
      width: 100%;
      display: block;
    }
  }
}
.user {
  margin-top: 10px;
  line-height: 30px;
  img {
    width: 30px;
    height: 30px;
    border-radius: 15px;
  }
  background-color: #fff;
  padding: 10px 10px 0 10px;
  display: flex;
  div {
    padding-right: 10px;
  }
}
.address {
  margin-top: 10px;
  background-color: #fff;
  padding: 10px;
}
</style>